<template>
    <div class="p-6 bg-red-900 min-h-screen flex justify-center items-center">
        <div class="w-full max-w-lg">
            <logo />
            <el-card class="leading-normal tracking-wider">
                <h1 class="text-center font-bold text-3xl">Bienvenido</h1>
                <div class="mx-auto mt-6 w-24 border-b-2" />

                <p class="my-2 underline uppercase">Hola  <b>{{ $page.props.auth.user.first_name }},  {{ $page.props.auth.user.last_name }}</b>:</p>
                <p class="m-1 ">Para empezar a usar la aplicacion necesita activar su cuenta a travez del link enviado a su casilla de correo.</p>

                <p class="m-1 truncate py-4 mx-auto bg-indigo-200 text-indigo-500 font-medium rounded-lg">Acordate de revisar tu casilla de correo no deseado.</p>

                <p class="m-1 ">En caso de aun no haberlo recibido puede volver a enviarlo haciendo click en el siguiente boton:</p>

                <div class="mt-4 items-center flex ">
                    <el-button type="primary" @click="resendEmail"> Reenviar Email de confirmacion</el-button>

                    <inertia-link class="ml-auto btn-register" :href="route('logout')" method="post" as="button">Salir</inertia-link>


                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue'
import Logo from '@/Shared/Logo'

export default {
    components:{
        Link,
        Logo,
    },
    data() {
        return {
        form: this.$inertia.form({
            email: 'johndoe@example.com',
            password: 'secret',
            remember: false,
        }),

        }
    },
    methods:{
        resendEmail(){
            this.$inertia.post(this.route('verification.resend'))
        },
        logout(){
            this.$inertia.post(this.route('logout'))
        }
    }
}
</script>
